import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=04b3a39a"
import script from "./TabItem.vue?vue&type=script&lang=ts"
export * from "./TabItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports